import { render } from "./RecordViewer.vue?vue&type=template&id=63bb37cd&scoped=true&ts=true"
import script from "./RecordViewer.vue?vue&type=script&lang=ts"
export * from "./RecordViewer.vue?vue&type=script&lang=ts"

import "./RecordViewer.vue?vue&type=style&index=0&id=63bb37cd&lang=scss&scoped=true"

import exportComponent from "/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-63bb37cd"]])

export default __exports__